// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("src/foundations/icons/magnifying-glass.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("src/foundations/icons/plus.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("src/foundations/icons/circle-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("src/foundations/icons/save.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("src/foundations/icons/trash-red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("src/foundations/icons/circle-xmark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("src/foundations/icons/circle-xmark-red.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("src/foundations/icons/clone.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiftref-button {
    padding-block: 0;
    padding-inline: 0;
    background: var(--accent-light-default);
    border: none;
    border-radius: var(--button-full-rounding);
    color: var(--text-default);
    font-family: var(--p2-medium-font-family), sans-serif;
    font-size: var(--p2-medium-font-size);
    letter-spacing: var(--p2-medium-letter-spacing);
    line-height: var( --p2-medium-line-height);
    font-weight: var(--p2-medium-font-weight);
    height: var(--spacing-40);
    padding: var(--spacing-10) var(--spacing-20);
    transition: all .3s cubic-bezier(.23,1,.32,1);
    user-select: none;
    width: max-content;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.swiftref-button[disabled] {
    background: var(--background-disabled);
    color: var(--text-disabled)!important;
    cursor: not-allowed;
}

a.swiftref-button {
    text-decoration: none;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}
.swiftref-button:not(:disabled):hover{
    background: var(--accent-light-hover);
    cursor: pointer;
}
.swiftref-button:not(:disabled):active {
    box-shadow: 0 0 0 0.2rem rgba(151,217,204,.5);
}
.swiftref-button:not(:disabled):focus-visible {
    outline: 1px solid var(--border-focused);
    /*box-shadow: 0 0 0 0.2rem rgba(151,217,204,.5);*/
}

[size="lg"].swiftref-button,
:host([size="lg"]) .swiftref-button {
    height: var(--spacing-50);
    padding: var(--spacing-10) var(--spacing-30);
}

/*secondary button*/
:host([kind="secondary"]) .swiftref-button {
    background: transparent;
    border: 1px solid var(--border-strong);
}
:host([kind="secondary"]) .swiftref-button:not([disabled]):hover {
    background: var(--accent-light-hover);
}

/*tertiary button*/
:host([kind="tertiary"]) .swiftref-button,
:host([kind="destructive-tertiary"]) .swiftref-button {
    font-family: var(--p2-regular-font-family), sans-serif;
    font-size: var(--p2-regular-font-size);
    letter-spacing: var(--p2-regular-letter-spacing);
    line-height: var( --p2-regular-line-height);
    font-weight: var(--p2-regular-font-weight);
    background: transparent;
    border: none;
    color: var(--accent-strong-default);
}
:host([kind="tertiary"]) .swiftref-button:not([disabled]):hover {
    background: var(--accent-light-hover);
}

/*destructive button*/
:host([kind="destructive"]) .swiftref-button {
    background: var(--background-error-strong);
    color: var(--text-ondark);
}
:host([kind="destructive"]) .swiftref-button:hover {
    background: var(--background-error-strong-hover);
}
/*start with destructive*/
:host([kind^="destructive"]) .swiftref-button:not(:disabled):active {
    box-shadow: none;
    outline: 1px solid var(--border-focused);
}

/*destructive secondary button*/
:host([kind="destructive-secondary"]) .swiftref-button {
    background: transparent;
    border: 1px solid var(--border-error-strong);
    color: var(--text-error);
}
:host([kind="destructive-secondary"]) .swiftref-button:not(:disabled):hover,
:host([kind="destructive-tertiary"]) .swiftref-button:not(:disabled):hover {
    background: var(--background-error-light-hover);
}
/*:host([kind="destructive-secondary"]) .swiftref-button:not(:disabled):active {*/
/*    background: none;*/
/*}*/

/*destructive tertiary button*/
:host([kind="destructive-tertiary"]) .swiftref-button {
    color: var(--text-error);
}

@media (max-width: 940px) {
    :host([visibility="desktop"]) {
        display: none;
    }
}


/* =============================================================================
icons
============================================================================= */

:host([icon]) .swiftref-button[disabled]::after,
:host([icon]) .swiftref-button[disabled]::before {
    opacity: .2;
}
:host([icon]) .swiftref-button::after,
:host([icon]) .swiftref-button::before {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-left: var(--spacing-10);
}
:host([icon][position]) .swiftref-button::after,
:host([icon][position]) .swiftref-button::before {
    content: unset;
    margin-left: unset;
}

/*default icon position is right*/
/*lens*/
:host([icon="lens"]) .swiftref-button::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
:host([icon="lens"][position="left"]) .swiftref-button::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    margin-right: var(--spacing-10);
}
/*plus*/
:host([icon="plus"]) .swiftref-button::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
:host([icon="plus"][position="left"]) .swiftref-button::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    margin-right: var(--spacing-10);
}
/*approve*/
:host([icon="approve"]) .swiftref-button::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
:host([icon="approve"][position="left"]) .swiftref-button::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    margin-right: var(--spacing-10);
}
/*save*/
:host([icon="save"]) .swiftref-button::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
:host([icon="save"][position="left"]) .swiftref-button::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    margin-right: var(--spacing-10);
}
/*trash-red*/
:host([icon="trash-red"]) .swiftref-button::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
:host([icon="trash-red"][position="left"]) .swiftref-button::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    margin-right: var(--spacing-10);
}
/*remove*/
:host([icon="remove"]) .swiftref-button::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
:host([icon="remove"][position="left"]) .swiftref-button::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    margin-right: var(--spacing-10);
}
/*remove-red*/
:host([icon="remove-red"]) .swiftref-button::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
:host([icon="remove-red"][position="left"]) .swiftref-button::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    margin-right: var(--spacing-10);
}
/*clone*/
:host([icon="clone"]) .swiftref-button::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
:host([icon="clone"][position="left"]) .swiftref-button::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    margin-right: var(--spacing-10);
}
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/button/style/index.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;IACvC,YAAY;IACZ,0CAA0C;IAC1C,0BAA0B;IAC1B,qDAAqD;IACrD,qCAAqC;IACrC,+CAA+C;IAC/C,0CAA0C;IAC1C,yCAAyC;IACzC,yBAAyB;IACzB,4CAA4C;IAC5C,6CAA6C;IAC7C,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,sCAAsC;IACtC,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;AAChC;AACA;IACI,qCAAqC;IACrC,eAAe;AACnB;AACA;IACI,6CAA6C;AACjD;AACA;IACI,wCAAwC;IACxC,iDAAiD;AACrD;;AAEA;;IAEI,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA,mBAAmB;AACnB;IACI,uBAAuB;IACvB,sCAAsC;AAC1C;AACA;IACI,qCAAqC;AACzC;;AAEA,kBAAkB;AAClB;;IAEI,sDAAsD;IACtD,sCAAsC;IACtC,gDAAgD;IAChD,2CAA2C;IAC3C,0CAA0C;IAC1C,uBAAuB;IACvB,YAAY;IACZ,mCAAmC;AACvC;AACA;IACI,qCAAqC;AACzC;;AAEA,qBAAqB;AACrB;IACI,0CAA0C;IAC1C,yBAAyB;AAC7B;AACA;IACI,gDAAgD;AACpD;AACA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA,+BAA+B;AAC/B;IACI,uBAAuB;IACvB,4CAA4C;IAC5C,wBAAwB;AAC5B;AACA;;IAEI,+CAA+C;AACnD;AACA,iFAAiF;AACjF,wBAAwB;AACxB,IAAI;;AAEJ,8BAA8B;AAC9B;IACI,wBAAwB;AAC5B;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;;AAGA;;+EAE+E;;AAE/E;;IAEI,WAAW;AACf;AACA;;IAEI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,8BAA8B;AAClC;AACA;;IAEI,cAAc;IACd,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC,OAAO;AACP;IACI,gDAA0D;AAC9D;AACA;IACI,gDAA0D;IAC1D,+BAA+B;AACnC;AACA,OAAO;AACP;IACI,gDAA8C;AAClD;AACA;IACI,gDAA8C;IAC9C,+BAA+B;AACnC;AACA,UAAU;AACV;IACI,gDAAsD;AAC1D;AACA;IACI,gDAAsD;IACtD,+BAA+B;AACnC;AACA,OAAO;AACP;IACI,gDAA8C;AAClD;AACA;IACI,gDAA8C;IAC9C,+BAA+B;AACnC;AACA,YAAY;AACZ;IACI,gDAAmD;AACvD;AACA;IACI,gDAAmD;IACnD,+BAA+B;AACnC;AACA,SAAS;AACT;IACI,gDAAsD;AAC1D;AACA;IACI,gDAAsD;IACtD,+BAA+B;AACnC;AACA,aAAa;AACb;IACI,gDAA0D;AAC9D;AACA;IACI,gDAA0D;IAC1D,+BAA+B;AACnC;AACA,QAAQ;AACR;IACI,gDAA+C;AACnD;AACA;IACI,gDAA+C;IAC/C,+BAA+B;AACnC","sourcesContent":[".swiftref-button {\n    padding-block: 0;\n    padding-inline: 0;\n    background: var(--accent-light-default);\n    border: none;\n    border-radius: var(--button-full-rounding);\n    color: var(--text-default);\n    font-family: var(--p2-medium-font-family), sans-serif;\n    font-size: var(--p2-medium-font-size);\n    letter-spacing: var(--p2-medium-letter-spacing);\n    line-height: var( --p2-medium-line-height);\n    font-weight: var(--p2-medium-font-weight);\n    height: var(--spacing-40);\n    padding: var(--spacing-10) var(--spacing-20);\n    transition: all .3s cubic-bezier(.23,1,.32,1);\n    user-select: none;\n    width: max-content;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n.swiftref-button[disabled] {\n    background: var(--background-disabled);\n    color: var(--text-disabled)!important;\n    cursor: not-allowed;\n}\n\na.swiftref-button {\n    text-decoration: none;\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n.swiftref-button:not(:disabled):hover{\n    background: var(--accent-light-hover);\n    cursor: pointer;\n}\n.swiftref-button:not(:disabled):active {\n    box-shadow: 0 0 0 0.2rem rgba(151,217,204,.5);\n}\n.swiftref-button:not(:disabled):focus-visible {\n    outline: 1px solid var(--border-focused);\n    /*box-shadow: 0 0 0 0.2rem rgba(151,217,204,.5);*/\n}\n\n[size=\"lg\"].swiftref-button,\n:host([size=\"lg\"]) .swiftref-button {\n    height: var(--spacing-50);\n    padding: var(--spacing-10) var(--spacing-30);\n}\n\n/*secondary button*/\n:host([kind=\"secondary\"]) .swiftref-button {\n    background: transparent;\n    border: 1px solid var(--border-strong);\n}\n:host([kind=\"secondary\"]) .swiftref-button:not([disabled]):hover {\n    background: var(--accent-light-hover);\n}\n\n/*tertiary button*/\n:host([kind=\"tertiary\"]) .swiftref-button,\n:host([kind=\"destructive-tertiary\"]) .swiftref-button {\n    font-family: var(--p2-regular-font-family), sans-serif;\n    font-size: var(--p2-regular-font-size);\n    letter-spacing: var(--p2-regular-letter-spacing);\n    line-height: var( --p2-regular-line-height);\n    font-weight: var(--p2-regular-font-weight);\n    background: transparent;\n    border: none;\n    color: var(--accent-strong-default);\n}\n:host([kind=\"tertiary\"]) .swiftref-button:not([disabled]):hover {\n    background: var(--accent-light-hover);\n}\n\n/*destructive button*/\n:host([kind=\"destructive\"]) .swiftref-button {\n    background: var(--background-error-strong);\n    color: var(--text-ondark);\n}\n:host([kind=\"destructive\"]) .swiftref-button:hover {\n    background: var(--background-error-strong-hover);\n}\n/*start with destructive*/\n:host([kind^=\"destructive\"]) .swiftref-button:not(:disabled):active {\n    box-shadow: none;\n    outline: 1px solid var(--border-focused);\n}\n\n/*destructive secondary button*/\n:host([kind=\"destructive-secondary\"]) .swiftref-button {\n    background: transparent;\n    border: 1px solid var(--border-error-strong);\n    color: var(--text-error);\n}\n:host([kind=\"destructive-secondary\"]) .swiftref-button:not(:disabled):hover,\n:host([kind=\"destructive-tertiary\"]) .swiftref-button:not(:disabled):hover {\n    background: var(--background-error-light-hover);\n}\n/*:host([kind=\"destructive-secondary\"]) .swiftref-button:not(:disabled):active {*/\n/*    background: none;*/\n/*}*/\n\n/*destructive tertiary button*/\n:host([kind=\"destructive-tertiary\"]) .swiftref-button {\n    color: var(--text-error);\n}\n\n@media (max-width: 940px) {\n    :host([visibility=\"desktop\"]) {\n        display: none;\n    }\n}\n\n\n/* =============================================================================\nicons\n============================================================================= */\n\n:host([icon]) .swiftref-button[disabled]::after,\n:host([icon]) .swiftref-button[disabled]::before {\n    opacity: .2;\n}\n:host([icon]) .swiftref-button::after,\n:host([icon]) .swiftref-button::before {\n    display: inline-block;\n    width: 14px;\n    height: 14px;\n    margin-left: var(--spacing-10);\n}\n:host([icon][position]) .swiftref-button::after,\n:host([icon][position]) .swiftref-button::before {\n    content: unset;\n    margin-left: unset;\n}\n\n/*default icon position is right*/\n/*lens*/\n:host([icon=\"lens\"]) .swiftref-button::after {\n    content: url(\"src/foundations/icons/magnifying-glass.svg\");\n}\n:host([icon=\"lens\"][position=\"left\"]) .swiftref-button::before {\n    content: url(\"src/foundations/icons/magnifying-glass.svg\");\n    margin-right: var(--spacing-10);\n}\n/*plus*/\n:host([icon=\"plus\"]) .swiftref-button::after {\n    content: url(\"src/foundations/icons/plus.svg\");\n}\n:host([icon=\"plus\"][position=\"left\"]) .swiftref-button::before {\n    content: url(\"src/foundations/icons/plus.svg\");\n    margin-right: var(--spacing-10);\n}\n/*approve*/\n:host([icon=\"approve\"]) .swiftref-button::after {\n    content: url(\"src/foundations/icons/circle-check.svg\");\n}\n:host([icon=\"approve\"][position=\"left\"]) .swiftref-button::before {\n    content: url(\"src/foundations/icons/circle-check.svg\");\n    margin-right: var(--spacing-10);\n}\n/*save*/\n:host([icon=\"save\"]) .swiftref-button::after {\n    content: url(\"src/foundations/icons/save.svg\");\n}\n:host([icon=\"save\"][position=\"left\"]) .swiftref-button::before {\n    content: url(\"src/foundations/icons/save.svg\");\n    margin-right: var(--spacing-10);\n}\n/*trash-red*/\n:host([icon=\"trash-red\"]) .swiftref-button::after {\n    content: url(\"src/foundations/icons/trash-red.svg\");\n}\n:host([icon=\"trash-red\"][position=\"left\"]) .swiftref-button::before {\n    content: url(\"src/foundations/icons/trash-red.svg\");\n    margin-right: var(--spacing-10);\n}\n/*remove*/\n:host([icon=\"remove\"]) .swiftref-button::after {\n    content: url(\"src/foundations/icons/circle-xmark.svg\");\n}\n:host([icon=\"remove\"][position=\"left\"]) .swiftref-button::before {\n    content: url(\"src/foundations/icons/circle-xmark.svg\");\n    margin-right: var(--spacing-10);\n}\n/*remove-red*/\n:host([icon=\"remove-red\"]) .swiftref-button::after {\n    content: url(\"src/foundations/icons/circle-xmark-red.svg\");\n}\n:host([icon=\"remove-red\"][position=\"left\"]) .swiftref-button::before {\n    content: url(\"src/foundations/icons/circle-xmark-red.svg\");\n    margin-right: var(--spacing-10);\n}\n/*clone*/\n:host([icon=\"clone\"]) .swiftref-button::after {\n    content: url(\"src/foundations/icons/clone.svg\");\n}\n:host([icon=\"clone\"][position=\"left\"]) .swiftref-button::before {\n    content: url(\"src/foundations/icons/clone.svg\");\n    margin-right: var(--spacing-10);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
